import { getEnvValue } from '@env/getEnvValue'

const datadogEnv = {
  NEXT_PUBLIC_ASAAS_DATADOG_CLIENT_TOKEN: getEnvValue(process.env.NEXT_PUBLIC_ASAAS_DATADOG_CLIENT_TOKEN),
  NEXT_PUBLIC_ASAAS_DATADOG_CLIENT_RUM_TOKEN: getEnvValue(process.env.NEXT_PUBLIC_ASAAS_DATADOG_CLIENT_RUM_TOKEN),
  NEXT_PUBLIC_ASAAS_DATADOG_CLIENT_RUM_APP_ID: getEnvValue(process.env.NEXT_PUBLIC_ASAAS_DATADOG_CLIENT_RUM_APP_ID),
  DATADOG_API_KEY: getEnvValue(process.env.DATADOG_API_KEY)
}

export { datadogEnv }
